import targetConstants from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetConstants';
import { locationTargetsOptionKeys } from '@bingads-webui-campaign-react/wizard-shared-components';

export function getIncludedLocationBasicConfig(i18n) {
  const columns = [
    {
      key: 'icon', name: '', fieldName: 'icon', minWidth: 32, maxWidth: 32, type: 'plainString', headerClassName: 'target-custom-header', raw: true, spanClassName: 'map-icon__pin--included', className: 'col-icon',
    },
    {
      key: 'location', name: i18n.getString(_TL_('Targeted locations')), fieldName: 'location', minWidth: 100, maxWidth: 333, type: 'plainString', headerClassName: 'target-custom-header',
    },
  ];
  return {
    basicConfig: {
      columns,
      showSettingToggle: true,
      enablePagination: true,
      hideWhenEmpty: true,
      minBid: -targetConstants.minimumBid.Location,
      maxBid: targetConstants.maximumBid.Location,
    },
  };
}

export function getExcludedLocationBasicConfig(i18n) {
  const columns = [
    {
      key: 'icon', name: '', fieldName: 'icon', minWidth: 32, maxWidth: 32, type: 'plainString', headerClassName: 'target-custom-header', spanClassName: 'map-icon__pin--excluded', className: 'col-icon',
    },
    {
      key: 'location', name: i18n.getString('Excluded locations'), fieldName: 'location', minWidth: 100, maxWidth: 333, type: 'plainString', headerClassName: 'target-custom-header',
    },
  ];
  return {
    basicConfig: {
      columns,
      showSettingToggle: true,
      noBidAdjustment: true,
      enablePagination: true,
      hideWhenEmpty: true,
    },
  };
}

export const defaultLocationData = {
  parentLevelSettings: {},
  currentLevelSettings: {
    targetOption: locationTargetsOptionKeys.everywhere,
    initLocations: [],
    peopleInLocation: true,
    peopleSearchingForLocation: true,
  },
  useParentLevel: false,
  bidMode: false,
};
